module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d57fa1b2d6cb01b2c7e55aacb679aa67.png";